module.exports = __webpack_public_path__ + "img/larva.8991c37b.svg";